import React from "react";
import "./Service.css";

const Service = () => {
    return (
        <div className="service-wrapper">
            <div className="works-title-wrapper">
                <span className="works-title-text">
                    Service
                </span>
            </div>
            <div className="service-body">


                <section className="service-contents-wrapper">
                    <div className="schedule-contents-title-wrapper">
                        <div className="schedule-contents-title-inner">
                            音楽コンテンツ制作
                        </div>
                    </div>
                    <div className="service-contents-body">
                        <div className="service-contents-message">
                            ボーカル入り楽曲、商業用BGM、劇伴など、多様な音楽コンテンツの作曲・編曲を承ります。<br />
                            特に、ジャズやソウル、R&B、ファンクといった要素を取り入れたポップスの制作を得意としており、独自のグルーヴ感や洗練されたメロディをお届けします。ジャンルにとらわれず、どのようなスタイルの楽曲にも柔軟に対応可能です。<br />
                            <br />
                            基本的に生音に準ずる自然な響きを大切にしながらも、シンセサイザーを活用した現代的なサウンドデザインにも対応しています。また、トラックメイキングやアレンジ、さらには特定の用途（動画、広告、舞台など）に最適化された楽曲制作も可能です。<br />
                            <br />

                            またカラオケの制作、譜起こしなども承っておりますので、ご相談ください。<br />
                            ご希望に寄り添った音楽を形にするお手伝いをいたします。<br />
                            <br />
                        </div>
                        <div className="servise-contents-tools">
                            <h3>作業環境</h3>

                            MacStudio M2 32GB/LogicPro11/SampleTank4/MODO Bass/synthesizer V<be />
                        </div>
                    </div>
                </section>


                <section className="service-contents-wrapper">
                    <div className="schedule-contents-title-wrapper">
                        <div className="schedule-contents-title-inner">
                            レコーディング・演奏サポート
                        </div>
                    </div>
                    <div className="service-contents-body">
                        <div className="service-contents-message">
                            ステージでのベース演奏サポートやレコーディングサポートを承ります。<br />
                            アシッドジャズ、ファンク、ソウル、R&Bといったグルーヴ感を重視したスタイルを得意としつつ、ポップスやロックなど多様なジャンルにも柔軟に対応可能です。<br />
                            <br />
                            ジャンルや楽曲の雰囲気に合わせた的確なプレイを提供し、ライブや録音の場で求められるサウンドを実現いたします。<br />
                            サポート内容やスケジュールに関する詳細はお気軽にご相談ください。<br />
                            <br />
                        </div>
                        <div className="servise-contents-tools">
                            <h3>使用機材</h3>

                            Momose5stJB/Sadowsky4stJB/Baccus4stFretless/<br />

                        </div>
                    </div>
                </section>

                <section className="service-contents-wrapper">
                    <div className="schedule-contents-title-wrapper">
                        <div className="schedule-contents-title-inner">
                            Web開発
                        </div>
                    </div>
                    <div className="service-contents-body">
                        <div className="service-contents-message">
                            中小規模のWeb開発を個人で承っています。シンプルなウェブサイトの構築やインタラクティブなウェブアプリケーションの開発、レスポンシブデザインを考慮したUI/UX設計など、多様なニーズに対応可能です。また、CMS（WordPressなど）を活用した柔軟なサイト構築や、必要に応じたカスタマイズにも対応しています。<br />
                            <br />
                            サーバーインフラ（AWSやVPS）を活用したバックエンド構築や、セキュアでスケーラブルなシステム設計にも経験があります。フロントエンドではReactやJavaScript、バックエンドではPHPやLaravelを使用し、プロジェクトの特性に応じて適切なツールを選択します。
                            <br /><br />
                            さらに、外部プロジェクトへの参加や特定の開発タスクの分担にも柔軟に対応しています。個人だからこそ可能なフレキシブルな姿勢で、進行状況や規模に合わせた寄り添ったサポートを心がけています。ぜひお気軽にお問い合わせいただければ、プロジェクトに最適なソリューションをご提案します。<br />
                        </div>
                        <div className="servise-contents-tools">
                            <h3>技術スタック</h3>

                            フロントエンド：Next.js/React/JavaScript/HTML/CSS/Saas<br />
                            バックエンド：PHP/Laravel/MySQL<br />
                            インフラ：AWS/Docker<br />
                        </div>
                    </div>
                </section>


            </div>
        </div >





    )

}
export default Service;